import { z } from 'zod';
import { feedbackFiltersSchema } from './feedback.schemes';

export const feedbackEntities = ['discount'] as const;
export type FeedbackEntity = (typeof feedbackEntities)[number];

export const feedbackStatuses = [
  'pending',
  'in_progress',
  'resolved',
  'closed',
] as const;
export type FeedbackStatus = (typeof feedbackStatuses)[number];

export interface FeedbackItem {
  id: string;
  entity: {
    variant: FeedbackEntity;
    id: string;
    label: string;
  };
  title: string;
  content: string;
  adminNotes: string;
  status: FeedbackStatus;
  employee: {
    id: string;
    fullName: string;
    email: string;
  } | null;
  admin: {
    id: string;
    fullName: string;
    email: string;
  } | null;
  resolvedByAdmin: {
    id: string;
    fullName: string;
  } | null;
  createdAt: string;
  resolvedAt: string | null;
  updatedAt: string | null;
}

export type FeedbackFilters = z.infer<typeof feedbackFiltersSchema>;
